<script lang="ts">
  import { params } from "svelte-spa-router";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import { getContext } from "svelte";
  import { StringUtils } from "$lib/stringUtils";
  import ProjectDetailForm from "./components/project-detail-form.svelte";

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);

  $: groupStoreId = $activeGroupStore?.groupStoreId;
  $: projectId = StringUtils.getNumberOrDefault($params?.projectId, 0);
   
</script>

{#if groupStoreId && projectId && $activeGroupStore?.stores}
  <ProjectDetailForm {groupStoreId} {projectId} stores={$activeGroupStore?.stores} />
{/if}
